var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_modal"},[_c('activity-modal'),_c('WinningModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }